import styles from './StarRating.module.css';

interface Props {
  stars: number;
  maxStars?: number;
}

export function StarRating({ stars, maxStars = 5 }: Props) {
  const clamped = Math.max(0, Math.min(stars, maxStars));

  return (
    <span
      className={styles.rating}
      role="img"
      aria-label={`${clamped} כוכבים`}
    >
      {Array.from({ length: maxStars }, (_, i) => (
        <span
          key={i}
          className={`${styles.star}${i < clamped ? ` ${styles.filled}` : ''}`}
          aria-hidden
        />
      ))}
    </span>
  );
}
